module.exports = __webpack_public_path__ + "static/media/icon-check-white.05c21982.svg";